const DetailsSection = ({ details }) => {
  return (
    <div className="grid gap-4">
      {details.map((detail, index) => (
        <div
          key={index}
          className="relative theme-card rounded-xl p-3 transition-colors group"
        >
          <div className="flex items-start space-x-3 space-x-reverse">
            <div className="theme-icon transition-colors group-hover:theme-icon-hover">
              {detail.icon}
            </div>
            <div className="flex-1">
              <h2 className="text-sm font-semibold theme-text-primary mb-0.5 transition-colors group-hover:theme-text-primary-hover">
                {detail.label}
              </h2>
              <p className="theme-text-secondary text-xs leading-relaxed line-clamp-2">
                {detail.value}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DetailsSection;